export function isNullOrWhitespace(str: string): boolean {
  return str === undefined || str === null || str.match(/^ *$/) !== null;
}
